module.exports = __webpack_public_path__ + "img/text2.24f3b79.svg";